import { render } from "./UserPayments.vue?vue&type=template&id=6d058721"
import script from "./UserPayments.vue?vue&type=script&lang=js"
export * from "./UserPayments.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__